import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-inner',
  templateUrl: './modal-inner.component.html'
})
export class ModalInnerComponent {
}